import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2b22d3a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "personal-content"
};
const _hoisted_2 = {
  class: "tips-wrap"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "根据相关法律法规要求，经营主体相关资质信息公示如下", -1));
const _hoisted_4 = {
  key: 0,
  class: "expire-text"
};
const _hoisted_5 = {
  class: "personal"
};
const _hoisted_6 = {
  class: "item"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "联系方式：", -1));
const _hoisted_8 = {
  class: "cont"
};
const _hoisted_9 = {
  class: "item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "经营地址：", -1));
const _hoisted_11 = {
  class: "cont"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_13 = {
  class: "info"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "经营主体自我声明", -1));
const _hoisted_15 = {
  class: "item cont"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, "✔️", -1));
import { useRoute } from "vue-router";
import { reactive, onMounted } from "vue";
import { getPersonQualificationInfo } from '@/api';
export default {
  setup(__props) {
    const state = reactive({
      user_id: '',
      contact: '',
      operate_address: '',
      business_type_zh: '',
      auth_expire_text: ''
    });
    const route = useRoute();
    onMounted(async () => {
      document.title = '个人经营者声明';
      state.user_id = route.params.user_id;
      const {
        status,
        data
      } = await getPersonQualificationInfo({
        user_id: state.user_id
      });
      if (status === 0 && data) {
        state.contact = data.contact || '';
        state.operate_address = data.operate_address || '';
        state.business_type_zh = data.business_type_zh || '';
        state.auth_expire_text = data.auth_expire_text || '';
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _unref(state).auth_expire_text ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(state).auth_expire_text), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(state).contact), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(state).operate_address), 1)]), _hoisted_12, _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", null, _toDisplayString(_unref(state).business_type_zh), 1)])])])]);
    };
  }
};